import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "status-text" }

import { computed } from 'vue';
import { useSpotifyAuth } from '@/composables/useSpotifyAuth';


export default /*@__PURE__*/_defineComponent({
  __name: 'SpotifyStatusBadge',
  setup(__props) {

const { isAuthenticated, isPremium } = useSpotifyAuth();

const statusText = computed(() => {
  if (!isAuthenticated.value) {
    return 'Nicht verbunden';
  }
  return isPremium.value ? 'Spotify Premium' : 'Spotify Free';
});

const statusClass = computed(() => {
  if (!isAuthenticated.value) {
    return 'status-disconnected';
  }
  return isPremium.value ? 'status-premium' : 'status-free';
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['status-badge', statusClass.value])
  }, [
    _cache[0] || (_cache[0] = _createElementVNode("span", { class: "status-dot" }, null, -1)),
    _createElementVNode("span", _hoisted_1, _toDisplayString(statusText.value), 1)
  ], 2))
}
}

})